let loading: Promise<void> | undefined;
/**
 * The authored solo clips (resident activities, hero idle gestures, each body's combat stances; `src/content/solo-animations`) are 1.4 million
 * keyframe values, so they are a chunk of their own, loaded after the start-up script; the browser gets them packed (`solo-clip-pack.ts`).
 * Fetched once; a scene waits for it before it first renders, and a clip that is not registered yet leaves the figure on its procedural pose.
 * Nothing on the server reads them.
 */
export const loadSoloClips = () => loading ??= import('../../../content/solo-animations/index.js').then(() => undefined);
